
//============================================================================= 
//                       <--- Developed By Icon Team ---> 
//============================================================================= 
 
// npm packages 
import React, { 
  useState, 
  useEffect, 
  useContext, 
  Fragment, 
  useCallback, 
} from "react"; 
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'; 
 
import * as moment from "moment"; 
import { useTranslation } from "react-i18next"; 
import { toast } from "react-toastify"; 
import { toastCss } from "assets/styleJS/global"; 
import { parseISO } from "date-fns"; 
import { useHistory } from "react-router"; 
 
// custom pages 
import Table from "components/Table/Table"; 
import ManageStartupAccountsAPI from "apis/manageStartupAccounts/manageStartupAccounts"; 
import AuditAPI from "apis/audit/audit"; 
import Context from "context/context"; 
import searchIcon from "assets/img/Search_Icon.png"; 
import { Styles } from "./styles"; 
import useDebounce from "helpers/useDebounce"; 
import access from "config/access"; 
import HistoryTable from "components/Table/History/HistoryTable"; 
import Loader from "components/Loader/Loader"; 
import { exporDatatHeaders } from "./Headers/headers"; 
 
import { CSVLink } from 'react-csv'; 
 
// material-ui 
import TextField from "@material-ui/core/TextField"; 
import { withStyles } from "@material-ui/core/styles"; 
import InputAdornment from "@material-ui/core/InputAdornment"; 
import FormControlLabel from "@material-ui/core/FormControlLabel"; 
import Switch from "@material-ui/core/Switch"; 
import Dialog from "@material-ui/core/Dialog"; 
import Button from "@material-ui/core/Button"; 
import { 
  MuiPickersUtilsProvider, 
  KeyboardDatePicker, 
} from "@material-ui/pickers"; 
import DateFnsUtils from "@date-io/date-fns"; 
import CircularProgress from "@material-ui/core/CircularProgress"; 
//import { MenuItem } from '@material-ui/core' 
 
 
// material-ui icons 
import Grid from "@material-ui/core/Grid"; 
import HighlightOffIcon from "@material-ui/icons/HighlightOff"; 
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined"; 
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'; 
import { blockInvalidChar } from "helpers/blockInvalidChar"; 
import HistoryIcon from "@material-ui/icons/History"; 
import { pointsFormat } from "helpers/dataFormat"; 
import editIcon from 'assets/img/editIcon.png'; 
import { is } from "date-fns/locale"; 
const Papa = require("papaparse/papaparse.min.js"); 
 
// custom TextField 
const CssTextField = withStyles({ 
  root: { 
    "& label.Mui-focused": { 
      color: "##D3D3D3", 
    }, 
    "& .MuiFormLabel-root": { 
      color: "#707070", 
    }, 
    "& .MuiInputBase-input": { 
      color: "#707070", 
    }, 
    "& .MuiInput-underline:before": { 
      borderBottomColor: "#707070!important", 
    }, 
    "& .MuiInput-underline:after": { 
      borderBottomColor: "#707070!important", 
    }, 
    "& .MuiOutlinedInput-root": { 
      "& fieldset": { 
        borderColor: "#707070", 
      }, 
      "&:hover fieldset": { 
        borderColor: "#707070", 
      }, 
      "&.Mui-focused fieldset": { 
        borderColor: "#707070", 
      }, 
      "&.MuiOutlinedInput-root": { 
        borderRadius: 20, 
      }, 
      "&.MuiOutlinedInput-root": { 
        marginTop: 0, 
        borderRadius: 20, 
        background: "#ededed", 
      }, 
    }, 
  }, 
})(TextField); 
 
 
const IOSSwitch = withStyles((theme) => ({ 
  root: { 
    width: 62, 
    height: 32, 
    padding: 0, 
    overflow: "visible", 
  }, 
 
  switchBase: { 
    padding: 3, 
    transition: "all 300ms ease", 
 
    "&$checked": { 
      transform: "translateX(30px)", 
      color: "#fff", 
 
      "& + $track": { 
        backgroundColor: "#22c55e", 
        opacity: 1, 
        boxShadow: "0 0 8px rgba(34, 197, 94, 0.35)", 
      }, 
 
      "& $thumb": { 
        transform: "scale(1.05)", 
      }, 
    }, 
 
    "&:active $thumb": { 
      transform: "scale(0.9)", 
    }, 
  }, 
 
  thumb: { 
    width: 26, 
    height: 26, 
    borderRadius: "50%", 
    backgroundColor: "#fff", 
    boxShadow: "0 2px 5px rgba(0,0,0,0.25)", 
    transition: "all 300ms ease", 
 
    "&:before": { 
      content: '"OFF"', 
      fontSize: 8, 
      fontWeight: 700, 
      color: "#6b7280", 
 
      position: "absolute", 
      top: "50%", 
      left: "50%", 
      transform: "translate(-50%, -50%)", 
    }, 
  }, 
 
  checked: {}, 
 
  track: { 
    borderRadius: 20, 
    backgroundColor: "#d1d5db", 
    opacity: 1, 
    transition: "all 300ms ease", 
  }, 
 
  // Change the text inside the thumb when checked 
  checkedThumb: {}, 
}))(Switch); 
const AutoRedeemSwitch = ({ checked, onChange,disabled }) => { 
  return ( 
    <div 
      onClick={() =>{ 
          if (disabled){
            toast.info("Auto redemption already completed for this shipto", { toastId: "auto-redeem-already-completed", });
             return; 
          }
            
           
        onChange({ 
          target: { 
            checked: !checked, 
          }, 
        }) 
     } 
      } 
      style={{ 
        width: "62px", 
        height: "30px", 
        borderRadius: "20px", 
        backgroundColor: checked ? "#22c55e" : "#d1d5db", 
        position: "relative", 
        cursor: "pointer", 
        transition: "all 0.3s ease", 
        boxShadow: checked 
          ? "0 0 8px rgba(34, 197, 94, 0.35)" 
          : "none", 
      }} 
    > 
      <div 
        style={{ 
          position: "absolute", 
          top: "3px", 
          left: checked ? "34px" : "3px", 
          width: "24px", 
          height: "24px", 
          borderRadius: "50%", 
          backgroundColor: "#fff", 
          transition: "all 0.3s ease", 
          boxShadow: "0 2px 5px rgba(0,0,0,0.2)", 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center", 
          fontSize: "8px", 
          fontWeight: 700, 
          color: checked ? "#22c55e" : "#6b7280", 
        }} 
      > 
        {checked ? "ON" : "OFF"} 
      </div> 
    </div> 
  ); 
}; 
 
export default function ShiptoDetails() { 
  const { getAPI, searchAPI, exportAPI,updateAutoRedeemConfig} = ManageStartupAccountsAPI(); 
  const { getCustomAuditAPI } = AuditAPI(); 
  const history = useHistory(); 
 
  const { state, dispatch } = useContext(Context); 
  const classes = Styles(); 
  const [showPeriodDropdown, setShowPeriodDropdown] = useState(false); 
  const [data, setData] = useState([]); 
  const [offset, setOffset] = useState(1); 
  const [count, setCount] = useState(0); 
  const [loading, setLoading] = useState(true); 
  const [searchValue, setSearchValue] = useState(""); 
 
  const [minimalDate, setMinimalDate] = useState(180); 
  const [isLoading, setIsLoading] = useState(false); 
 
  const [updateLoading, setUpdateLoading] = useState(false); 
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false); 
  const [exportData, setExportData] = useState([]); 
  const [exportHeaders, setExportHeaders] = useState([]); 
  const [exportFileName, setExportFileName] = useState(""); 
 
 
  const [fileName, setFileName] = useState(""); 
 
  // Common State Object 
  const [states, setstates] = useState({ 
    clearSearch: false, 
    historyDialog: false, 
    historyLoader: false, 
    data: [] 
  }); 
 
 
  const setStates = useCallback((newState) => { 
    setstates((states) => ({ ...states, ...newState })); 
  }, []); 
 
  const { historyLoader } = states; 
  let searchBounceValues = useDebounce(() => { 
    return searchValue === '' ? '' : searchValue; 
  }); 
  const { clearSearch } = states; 
  const { t, i18n } = useTranslation(); 
 
  const [autoRedeemConfirmation, setAutoRedeemConfirmation] = useState({ 
    open: false, 
    data: null, 
    checked: false, 
    index: null, 
  }); 
   
  let tableHeading = [ 
    "Member ID", 
    "Billto", 
    "Shipto", 
    "Shipto Name", 
    "Startup Status", 
    //'Payment Plan', 
    "Startup Start Date", 
    "Startup End Date", 
    "Multiplier Status", 
   // "Earning Status", 
   // "", 
    // "Start Date", 
    // "End Date", 
    // "Enroll/Cancel Signature", 
    "History", 
     (state?.userInfo?.role_id == 13  ||state?.userInfo?.role_id == 10)? "Auto Redeem":'' 
  ] 
    
  const handlePagination = (value) => { 
    setOffset(value); 
  }; 
 
  useEffect(() => { 
    if (!clearSearch) { 
      if (searchBounceValues && searchBounceValues.length > 0) { 
        handleSearch(); 
      } 
      else { 
        handleGet(); 
      } 
    } 
    else { 
      setStates({ clearSearch: false }); 
    } 
  }, [searchBounceValues, offset]); 
 
  useEffect(() => { 
    dispatch({ 
      type: "SET_PATHNAME", 
      payload: ["HOME", "ADMIN", "MANAGE SIGNATURE ACCOUNTS"], 
    }); 
  }, []); 
 
  // Get data API 
  async function handleGet() { 
    try { 
      setLoading(true); 
      let values; 
      values = { 
        offset: (offset - 1) * 10, 
        limit: 10, 
      }; 
 
      dispatch({ type: "SET_LOADING", payload: true }); 
      let res = await getAPI(values); 
      if (res) { 
        setData(res.data); 
        setCount(res.count); 
        setMinimalDate(res?.minimaldate) 
        setLoading(false); 
        dispatch({ type: "SET_LOADING", payload: false }); 
      } 
    } catch (e) { 
      console.log({ e }); 
    } 
  } 
 
  // Search data API 
  async function handleSearch() { 
    try { 
      setLoading(true); 
      let values; 
      values = { 
        search: searchValue, 
        offset: (offset - 1) * 10, 
        limit: 10, 
      }; 
 
      dispatch({ type: "SET_LOADING", payload: true }); 
      let res = await searchAPI(values); 
      if (res) { 
        setData(res.data); 
        setCount(res.count); 
        setMinimalDate(res?.minimaldate) 
        setLoading(false); 
        dispatch({ type: "SET_LOADING", payload: false }); 
      } 
    } catch (e) { 
      console.log({ e }); 
    } 
  } 
 
  
 
  // Get signature history 
  const handleGetHistoryData = async (id) => { 
    try { 
      let values; 
      values = { 
        recordId: id, 
        feature: "manageStartupAccounts", 
      }; 
      let res = await getCustomAuditAPI(values); 
      if (res) { 
        setStates({ historyData: res?.data, historyLoader: false }); 
      } 
    } catch (e) { 
      console.log({ e }); 
    } 
  }; 
 
    // Get signature history 
const handleUpdateAutopRedeem = async (d, checked) => { 
  try { 
    const values = { 
      shipto: d?.customer_account_number, 
      checked: !checked, 
      loyaltyID: d?.loyalty_id, 
    }; 
console.log('called times 123') 
    const res = await updateAutoRedeemConfig(values); 
console.log(res,'thsi is the response') 
    if (res?.count > 0) { 
      toast.success("Auto Redeem updated successfully", { 
        toastId: `config-updated-${d?.customer_account_number}-${checked}`, 
      }); 
      return true; 
    } 
 
    toast.error("Unable to update Auto Redeem. Please try again.", { 
      toastId: `config-updated-failed-${d?.customer_account_number}-${checked}`, 
    }); 
    return false; 
 
  } catch (e) { 
    console.log({ e }); 
 
    toast.error("Failed to update Auto Redeem. Please try again.", { 
      toastId: `config-update-error-${d?.customer_account_number}-${checked}`, 
    }); 
 
    return false; 
  } 
}; 

 const handleAutoRedeemChange = (d, checked, i) => {
    setAutoRedeemConfirmation({
      open: true,
      data: d,
      checked: checked,
      index: i,
    });
  };

  const handleConfirmAutoRedeem = async (d, checked, i) => {
    setAutoRedeemConfirmation({
      open: false,
      data: null,
      checked: false,
      index: null,
    });

    let res=await handleUpdateAutopRedeem(d,checked) 
    console.log(res,'ththis i sthe res')
    if(res){
      setData([
                        ...data.slice(0, i),
                        { ...data[i], auto_redeemed_flag: !checked },
                        ...data.slice(i + 1),
                      ]);

    }else{
      setData([
                        ...data.slice(0, i),
                        { ...data[i], auto_redeemed_flag: checked },
                        ...data.slice(i + 1),
                      ]);
    }
  };
 
  const handleExport = async () => { 
    let values = {}; 
    if (searchValue) { 
      values = { ...values, searchValue }; 
    } 
 
    dispatch({ type: "SET_LOADING", payload: true }); 
    setIsLoading(true); 
 
    let res = await exportAPI(values); 
    if (res && res?.type === "ERROR") { 
      dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 }); 
      setStates({ 
        pLoading: false, 
        eLoading: false, 
        errorDialog: true, 
        errorCount: res?.count, 
      }); 
    } 
 
    if (res && res.data) { 
      dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 }); 
      setExportData(res.data.map(obj => { 
        return { 
 
          ...obj, 
          startup_flag: obj?.startup_flag ? 'Active' : 'Not Active', 
          multiplier: obj?.multiplier ? `${obj.multiplier === 1 ? 1.5 : obj.multiplier}X` : '-', 
        } 
      })); 
      setExportFileName('STARTUP_ACCOUNTS') 
      setExportHeaders(exporDatatHeaders) 
      dispatch({ type: "SET_LOADING", payload: false }); 
      setIsLoading(false); 
      setStates({ 
        response: true, 
        pLoading: false, 
        eLoading: false, 
      }); 
      if (res.data.length === 0) { 
        toast.success(t("No Data Found"), { toastId: "no-report-date" }); 
        return false; 
      } 
      return true; 
    } 
  }; 
 
  return ( 
    <Fragment> 
      <Grid xs={12} sm={12} lg={12} className={classes.topGrid}> 
        <CssTextField 
          id="enterPassword" 
          placeholder={t("Search for Billto or Shipto")} 
          onKeyDown={blockInvalidChar} 
          type={"number"} 
              onWheel={(e) => e.target.blur()}
          variant="outlined" 
          autoComplete="off" 
          className={classes.searchInput} 
          InputProps={{ 
            endAdornment: ( 
              <InputAdornment position="end"> 
                {searchValue.length > 0 ? ( 
                  <CloseOutlinedIcon 
                    className={classes.searchInputIcon} 
                    onClick={() => { 
                      setStates({ clearSearch: true }); 
                      setSearchValue(""); 
                      if (offset === 1) { 
                        handleGet(); 
                      } 
                      else { 
                        setOffset(1); 
                      } 
                    }} 
                  /> 
                ) : ( 
                  <img 
                    src={searchIcon} 
                    alt="" 
                    width="20px" 
                    className={classes.searchInputIcon} 
                  /> 
                )} 
              </InputAdornment> 
            ), 
          }} 
          value={searchValue} 
          onChange={(e) => { 
            e.target.value.replace(/\s+/g, "").length == 0 
              ? setSearchValue("") 
              : setSearchValue(e.target.value); 
            if (e.target.value.length == 0) { 
              handleGet(); 
            } 
          }} 
          onClick={() => { 
            setOffset(1); 
          }} 
        /> 
        <div> 
          {/* <button className={classes.blukUploadBtn} onClick={() => setBulkUploadOpen(true)}>Signature Offboarding</button> */} 
          <button 
            className={classes.exportBtn} 
            onClick={async () => { 
              setStates({ response: false, data: [], eLoading: true }); 
              let res = await handleExport(); 
              if (res) { 
                let data = []; 
                document.getElementById("csv").click(); 
              } 
            }} 
            disabled={states.eLoading || states.pLoading} 
          > 
            {states.eLoading ? ( 
              'Loading...' 
            ) : ( 
              ` Export ` 
            )} 
          </button> 
        </div> 
      </Grid> 
      <div style={{ marginTop: 20 }}> 
        {!loading ? ( 
          <Table 
            headings={tableHeading.map((i) => { 
              return <div key={t(i)}>{t(i)}</div>; 
            })} 
            data={ 
              data && 
              data.length > 0 && 
              data.map((d, i) => [ 
                d?.loyalty_id, 
                  d?.customer_billto_account_number, 
                  d?.customer_account_number, 
                  d?.Customer_Account_customer_name, 
                  d?.startup_flag ? 
                      ( 
                        <span className={classes.greenBtn}>{"Active "}</span> 
                      ) : ( 
                      <span className={classes.blackBtn} style={{ whiteSpace: 'nowrap' }}>Not Active</span> 
   
                    ), 
                    d?.startup_start_date, 
                    d?.startup_end_date, 
                    d?.multiplier ? `${d.multiplier === 1 ? 1.5 : d.multiplier}X` : '-', 
                state?.userInfo?.auditAccess && ( 
                  <HistoryIcon 
                    style={{ cursor: "pointer", verticalAlign: "middle" }} 
                    onClick={() => { 
                      setStates({ 
                        historyDialog: true, 
                        historyLoader: true, 
                      }); 
                      handleGetHistoryData(d?._id); 
                    }} 
                  /> 
                ), 
                (state?.userInfo?.role_id == 13  ||state?.userInfo?.role_id == 10) &&( 
               <FormControlLabel 
  control={ 
    <AutoRedeemSwitch 
      checked={ d?.auto_redeem_already_done == 1 
      ? true 
      : Boolean(!d?.auto_redeemed_flag)} 
     disabled={d?.auto_redeem_already_done == 1} 
           onChange={(event) => {
        let checked =event.target.checked
        console.log(
          event.target.checked ? "Auto Redeem ON" : "Auto Redeem OFF"
        );
        handleAutoRedeemChange(d, checked, i);
      }}
    /> 
  } 
/> 
                ) 
                 
              ]) 
            } 
            offset={offset} 
            count={ 
              (count / 10) % 1 == 0 
                ? Math.floor(count / 10) 
                : Math.floor(count / 10 + 1) 
            } 
            handlePagination={handlePagination} 
          /> 
        ) : ( 
          <div 
            style={{ 
              height: "25vh", 
              display: "flex", 
              justifyContent: "center", 
              alignItems: "center", 
            }} 
          > 
            <h2>{t("Loading...")}</h2> 
          </div> 
        )} 
      </div> 

      {/* Auto Redeem Confirmation Dialog */} 
<Dialog
  open={autoRedeemConfirmation.open}
  onClose={() => {
    setAutoRedeemConfirmation({
      open: false,
      data: null,
      checked: false,
      index: null,
    });
  }}
  maxWidth="sm"
  fullWidth
  scroll="paper"
  PaperProps={{
    style: {
      borderRadius: 16,
      overflow: "hidden",
      boxShadow: "0px 12px 40px rgba(0, 0, 0, 0.20)",
      fontFamily: "Segoe-ui",
      maxHeight: "90vh",
    },
  }}
>
  {/* Header */}
  <div
    style={{
      position: "relative",
      background:
        "linear-gradient(135deg, #2F7CBD 0%, #155A91 100%)",
      padding: "22px 26px",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      flexShrink: 0,
    }}
  >
    {/* Close Button */}
    <div
      onClick={() => {
        setAutoRedeemConfirmation({
          open: false,
          data: null,
          checked: false,
          index: null,
        });
      }}
      style={{
        position: "absolute",
        top: 12,
        right: 12,
        width: 34,
        height: 34,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color: "rgba(255,255,255,0.85)",
        background: "rgba(255,255,255,0.12)",
        transition: "all 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background =
          "rgba(255,255,255,0.25)";
        e.currentTarget.style.color = "#FFFFFF";
        e.currentTarget.style.transform = "rotate(90deg)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background =
          "rgba(255,255,255,0.12)";
        e.currentTarget.style.color =
          "rgba(255,255,255,0.85)";
        e.currentTarget.style.transform = "rotate(0deg)";
      }}
    >
      ×
    </div>

    {/* Auto Redeem Icon */}
    <div
      style={{
        width: 48,
        height: 48,
        borderRadius: "50%",
        background: "rgba(255,255,255,0.18)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: 15,
        fontSize: 23,
        fontWeight: "bold",
      }}
    >
      A
    </div>

    {/* Header Text */}
    <div>
      <div
        style={{
          fontSize: 21,
          fontWeight: 600,
          lineHeight: 1.2,
        }}
      >
        Auto Redeem
      </div>

      <div
        style={{
          fontSize: 13,
          marginTop: 5,
          opacity: 0.9,
        }}
      >
        Confirm account setting change
      </div>
    </div>
  </div>

  {/* Body */}
  <div
    style={{
      padding: "26px 28px 24px",
      background: "#fff",
      overflowY: "auto",
      maxHeight: "calc(90vh - 100px)",
      boxSizing: "border-box",
    }}
  >
    {/* Status */}
  {/* Current Status */}
<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "#F6F8FA",
    border: "1px solid #E3E8ED",
    borderRadius: 12,
    padding: "16px 18px",
    marginBottom: 20,
  }}
>
  <div>
    <div
      style={{
        fontSize: 13,
        color: "#707070",
        marginBottom: 5,
      }}
    >
      Auto Redeem Current Status
    </div>

    <div
      style={{
        fontSize: 19,
        fontWeight: 600,
        color:
          !autoRedeemConfirmation?.data?.auto_redeemed_flag
            ? "#2E7D32"
            : "#D32F2F",
      }}
    >
      {!autoRedeemConfirmation?.data?.auto_redeemed_flag
        ? "ON"
        : "OFF"}
    </div>
  </div>

  {/* Status Icon */}
  <div
    style={{
      width: 44,
      height: 44,
      borderRadius: "50%",
      background:
        !autoRedeemConfirmation?.data?.auto_redeemed_flag
          ? "#E8F5E9"
          : "#FFEBEE",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color:
        !autoRedeemConfirmation?.data?.auto_redeemed_flag
          ? "#2E7D32"
          : "#D32F2F",
      fontSize: 22,
      fontWeight: "bold",
    }}
  >
    {!autoRedeemConfirmation?.data?.auto_redeemed_flag
      ? "✓"
      : "×"}
  </div>
</div>

    {/* Customer Details */}
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 12,
        marginBottom: 20,
      }}
    >
      {/* Shipto */}
      <div
        style={{
          border: "1px solid #E5E5E5",
          borderRadius: 10,
          padding: "12px 14px",
        }}
      >
        <div
          style={{
            fontSize: 11,
            color: "#888",
            marginBottom: 5,
            textTransform: "uppercase",
          }}
        >
          Shipto
        </div>

        <div
          style={{
            fontSize: 15,
            fontWeight: 600,
            color: "#333",
          }}
        >
          {autoRedeemConfirmation?.data
            ?.customer_account_number || "-"}
        </div>
      </div>

      {/* Member ID */}
      <div
        style={{
          border: "1px solid #E5E5E5",
          borderRadius: 10,
          padding: "12px 14px",
        }}
      >
        <div
          style={{
            fontSize: 11,
            color: "#888",
            marginBottom: 5,
            textTransform: "uppercase",
          }}
        >
          Member ID
        </div>

        <div
          style={{
            fontSize: 15,
            fontWeight: 600,
            color: "#333",
          }}
        >
          {autoRedeemConfirmation?.data?.loyalty_id || "-"}
        </div>
      </div>
    </div>

    {/* Confirmation Message */}
    <div
      style={{
        background: autoRedeemConfirmation?.checked
          ? "#F0F7FC"
          : "#FFF7F7",
        borderLeft: `4px solid ${
          autoRedeemConfirmation?.checked
            ? "#2F7CBD"
            : "#D32F2F"
        }`,
        borderRadius: "0 8px 8px 0",
        padding: "14px 16px",
        marginBottom: 24,
      }}
    >
      <div
        style={{
          fontSize: 14,
          color: "#333",
          lineHeight: 1.6,
        }}
      >
        You are about{" "}
        <strong>
          {autoRedeemConfirmation?.checked
            ? "turn ON"
            : "turn OFF"}
        </strong>{" "}
        Auto Redeem for this customer.
      </div>

      <div
        style={{
          fontSize: 12,
          color: "#777",
          marginTop: 5,
        }}
      >
        Please confirm that you want to continue with this
        change.
      </div>
    </div>

    {/* Buttons */}
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        paddingTop: 4,
      }}
    >
      {/* Cancel Button */}
      <Button
        variant="contained"
        onClick={() => {
          setAutoRedeemConfirmation({
            open: false,
            data: null,
            checked: false,
            index: null,
          });
        }}
        style={{
          minWidth: 110,
          height: 44,
          borderRadius: 10,
          textTransform: "none",
          fontSize: 14,
          fontWeight: 600,
          marginRight: 12,
          color: "#FFFFFF",
          background: "#7A7F85",
          boxShadow: "0 3px 8px rgba(0, 0, 0, 0.15)",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#555A60";
          e.currentTarget.style.boxShadow =
            "0 5px 12px rgba(0, 0, 0, 0.22)";
          e.currentTarget.style.transform =
            "translateY(-1px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#7A7F85";
          e.currentTarget.style.boxShadow =
            "0 3px 8px rgba(0, 0, 0, 0.15)";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        Cancel
      </Button>

      {/* Confirm Button */}
      <Button
        variant="contained"
        onClick={() => {
          handleConfirmAutoRedeem(
            autoRedeemConfirmation.data,
            autoRedeemConfirmation.checked,
            autoRedeemConfirmation.index
          );
        }}
        style={{
          minWidth: 145,
          height: 44,
          borderRadius: 10,
          textTransform: "none",
          fontSize: 14,
          fontWeight: 600,
          color: "#FFFFFF",
          background: autoRedeemConfirmation?.checked
            ? "linear-gradient(135deg, #2F7CBD 0%, #155A91 100%)"
            : "linear-gradient(135deg, #D32F2F 0%, #B71C1C 100%)",
          boxShadow: autoRedeemConfirmation?.checked
            ? "0 4px 12px rgba(47, 124, 189, 0.28)"
            : "0 4px 12px rgba(211, 47, 47, 0.25)",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform =
            "translateY(-1px)";
          e.currentTarget.style.boxShadow =
            autoRedeemConfirmation?.checked
              ? "0 6px 16px rgba(47, 124, 189, 0.35)"
              : "0 6px 16px rgba(211, 47, 47, 0.32)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow =
            autoRedeemConfirmation?.checked
              ? "0 4px 12px rgba(47, 124, 189, 0.28)"
              : "0 4px 12px rgba(211, 47, 47, 0.25)";
        }}
      >
        <>
          <span
            style={{
              marginRight: 8,
              fontSize: 16,
              lineHeight: 1,
            }}
          >
            {autoRedeemConfirmation?.checked ? "✓" : "!"}
          </span>

          {autoRedeemConfirmation?.checked
            ? "Turn ON"
            : "Turn OFF"}
        </>
      </Button>
    </div>
  </div>
</Dialog>
      {/* Audit Logs Dialog */} 
      <Dialog 
        aria-labelledby="simple-dialog-title" 
        open={states.historyDialog} 
        style={{ fontFamily: "Segoe-ui" }} 
        maxWidth={false} 
      > 
        <div className={classes.dialogParentDiv}> 
          <div 
            className={classes.parentText} 
            style={{ 
              paddingBottom: 10, 
              width: states?.historyData?.length > 0 ? "100%" : 300, 
            }} 
          > 
            History{" "} 
            <span style={{ float: "right" }}> 
              <HighlightOffIcon 
                style={{ 
                  cursor: "pointer", 
                  color: "red", 
                  fontSize: 35, 
                }} 
                onClick={() => { 
                  setStates({ historyDialog: false, historyData: [] }); 
                }} 
              /> 
            </span> 
          </div> 
 
          {!historyLoader ? ( 
            <HistoryTable 
              headings={[ 
                "Date of Change", 
                "Updated by", 
                "Setting", 
                "Description", 
                "Reason", 
              ]} 
              data={ 
                states?.historyData?.length > 0 && 
                states?.historyData.map((d, i) => [ 
                  d?.created_at 
                    ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}` 
                    : "", 
                  `${d?.["User.email"] 
                    ? d?.["User.email"] 
                    : d?.altered_by 
                      ? d?.altered_by.charAt(0).toUpperCase() + 
                      d?.altered_by.slice(1).toLowerCase() 
                      : "-" 
                  }`, 
                  d?.column_name, 
                  `"${!d?.old_value 
                    ? "not set" 
                    : moment(d?.old_value, [ 
                      "YYYY-MM-DD", 
                      "YYYY-MM-DD HH:mm:ss", 
                      "ddd MMM DD YYYY HH:mm:ss [GMT]Z" 
                    ], true).isValid() 
                      ? moment(d?.old_value).format("MMM DD YYYY") 
                      : d?.old_value 
                  }" changed to "${!d?.new_value 
                    ? "not set" 
                    : moment(d?.new_value, [ 
                      "YYYY-MM-DD", 
                      "YYYY-MM-DD HH:mm:ss", 
                      "ddd MMM DD YYYY HH:mm:ss [GMT]Z" 
                    ], true).isValid() 
                      ? moment(d?.new_value).format("MMM DD YYYY") 
                      : d?.new_value 
                  }"` 
                  , 
 
                  d?.reason, 
                ]) 
              } 
              disablePagination={true} 
            /> 
          ) : ( 
            <div> 
              <Loader Loading={historyLoader} top={"15%"}></Loader> 
            </div> 
          )} 
        </div> 
      </Dialog> 
     
      <CSVLink 
        id='csv' 
        data={exportData} 
        headers={exportHeaders} 
        filename={exportFileName + 
          ' ' + 
          moment(new Date()).format('MM-DD-YYYY,h:mm A') + 
          '.csv' 
        } 
        className={classes.CSVlink} 
      /> 
    </Fragment > 
  ); 
} 
 
